import React, { Component } from "react";
import { Link, withRouter } from 'react-router-dom';
import Input from "../common/Input";
import * as Icon from "react-feather";
import { ToastContainer } from 'react-toastify';
import { toaster } from '../../config';
import CustomLoader from '../common/Loader';
import { logActivity } from '../../services/utilService';
import { Tab, Tabs } from "react-bootstrap";
import AddReport from "./AddReport";
import AddVariables from './AddVariables';
import DisplayMetrics from "./DisplayMetrics";
import AddDataSource from './AddDataSource';

class ReportSettings extends Component {


    constructor(props) {
        super(props);

        this.state = {
            rowData: this.props.history.location.state.rowData || [],
            loading: false
        };

    }

    async componentDidMount() {
        //console.log('ReportSettings componentDidMount', this.state, this.props);
    }

    render() {
        const { rowData } = this.state;

        const loading = (<CustomLoader loading={this.state.loading} />);
        try {
            if (this.state.loading) { return loading }
            else {
                return (
                    <React.Fragment>
                        <header className='page-header page-header-dark bg-gradient-primary-to-secondary'>
                            <div className='container'>
                                <div className='page-header-content pt-4'>
                                    <div className='row align-items-center justify-content-between'>
                                        <div className='col-auto mt-4'>
                                            <h1 className='page-header-title'>
                                                <div className='page-header-icon'>
                                                    <Icon.Settings />
                                                </div>
                                                Report Settings
                                            </h1>
                                            <div className='page-header-subtitle'>
                                                Configure your Report here.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <ol className="breadcrumb mb-0 mt-4">
                                <li className="breadcrumb-item">
                                    <Link to={{ pathname: "/ReportBuilder/" }}>Reports</Link>
                                </li>
                                <li className="breadcrumb-item active">{rowData[1]}</li>
                            </ol>
                        </header>
                        <div className="container mt-2">
                            <Tabs defaultActiveKey="AddReport" variant="pills" className="rounded-0">
                                <Tab eventKey="AddReport" title="Basic">
                                    <div className="card mt-2">
                                        <AddReport preloadData={rowData} />
                                    </div>
                                </Tab>
                                <Tab eventKey="AddDataSource" title="Data Source" disabled={false}>
                                    <AddDataSource />
                                </Tab>
                                <Tab eventKey="AddVariables" title="Variables" disabled={true}>
                                    <div className="card mt-2">
                                        <AddVariables />
                                    </div>
                                </Tab>
                                <Tab eventKey="DisplayMetrics" title="Display Metrics" disabled={false}>
                                    <div className="card mt-2">
                                        <DisplayMetrics />
                                    </div>
                                </Tab>
                            </Tabs>
                        </div>
                    </React.Fragment >
                );
            }
        }
        catch (e) {
            console.error('Error loading Report Builder: ', e);
            return (loading);
        }
    }
}

export default withRouter(ReportSettings);